import React from 'react';

export interface ErrorboxProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Error content
   */
  children: React.ReactNode;
  /**
   * Custom CSS classes
   */
  className?: string;
  /**
   * Inline styles
   */
  style?: React.CSSProperties;
  /**
   * HTML id attribute
   */
  id?: string;
}

export const Errorbox: React.FC<ErrorboxProps> = ({
  children,
  className = '',
  style,
  id,
  ...rest
}) => {
  const baseClass = 'hi-ui-errorbox';
  const allClasses = `${baseClass} ${className}`.trim();

  return (
    <div className={allClasses} style={style} id={id} {...rest}>
      {children}
    </div>
  );
};
